import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { TableOutline } from '../../elements'
import {
  getTableHeadings,
  ACCOUNTS
} from './constant'
import { requestService } from '../../Services/RequestService/RequestService'
import StatusButton from '../../Components/StatusButton'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Grid, FormLabel, Box } from '@material-ui/core'
import * as messageTypes from '../../utils/messageTypes'
import DisplayMessage from '../../Components/DisplayMessage'
import { COMMON } from '../../utils/constants'
import { useStyles } from './style'
import { AppButton, ComponentLoader, Loader } from '../../Components'
import CustomDialog from '../../Components/CustomDialog'
import moment from 'moment'
import { timeZoneAbbrs } from '../../utils/momentTimezones'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

function AllRequests(props) {
  const classes = useStyles()
  const [requestData, setRequestData] = useState([])
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(messageTypes.INFO)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState(0)

  const getAllRequests = (account_id) => {
    setLoading(true)
    const params = { page_no: page - 1, page_size: props.page ? 3 : rowsPerPage }
    requestService.getAllRequests(account_id, params)
      .then(requestData => {
        setRequestData(requestData.users_list)
        setRequestTable(requestData.users_list)
        setTotalCount(requestData.total_count)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(error, 'data.error.displayMessage', 'Failed to fetch requests')
        setMessageType(messageTypes.ERROR)
      })
  }

  const setRequestTable = (requestData) => {
    let requestTable = []
    requestData.map(obj => {
      let tableObj = [
        {
          id: 'accountName',
          value: _.get(obj, 'account.company_name', '-'),
          email: _.get(obj, 'email', ''),
          handleClick: () => { setSelectedRequest(obj); setOpenModal(true) },
          className: props.page && props.page === 'admin' && classes.nameInAccountTable,
        },
        {
          id: 'requestedBy',
          value: _.get(obj, 'name', '')
        },
        ...(!props.page ? [{
          id: 'date&time',
          value: obj && obj.signup_timestamp && obj.account ? moment.tz(obj.signup_timestamp, obj.account.timezone).utc().tz(props.timeZone).format('Do MMM YYYY h:mm A zz') : 'Not Available'
        }] : []),
      ]
      requestTable.push(tableObj)
    })
    setTableData(requestTable)
  }

  const handleClose = () => {
    setOpenModal(false)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const approveRequest = (data) => {
    setLoading(true)
    let obj = { approval_status: 'APPROVED', email: data.email }
    requestService.approveRequest(obj, props.currentUser.account_id)
      .then(requestData => {
        setMessage(requestData)
        setOpen(true)
        setMessageType(messageTypes.SUCCESS)
        setOpenModal(false)
        getAllRequests(props.currentUser.account_id)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to approve requests'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const rejectRequest = (data) => {
    setLoading(true)
    let obj = { approval_status: 'REJECTED', email: data.email }
    requestService.rejectRequest(obj, props.currentUser.account_id)
      .then(requestData => {
        setMessage(requestData)
        setOpen(true)
        setMessageType(messageTypes.SUCCESS)
        setOpenModal(false)
        getAllRequests(props.currentUser.account_id)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to reject requests'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  const getDialogContent = () => (
    <Box px={2} pt={2}>
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <div className={classes.cardData}>Company Name</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'account.company_name', '-')}</span>
        </Grid>
        <Grid item sm={6}>
          <div className={classes.cardData}>Address</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'account.address', '-')}</span>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <div className={classes.cardData}>Email</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'email', '-')}</span>
        </Grid>
        <Grid item sm={6}>
          <div className={classes.cardData}>City</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'account.city', '-')}</span>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <div className={classes.cardData}>Full Name</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'name', '-')}</span>
        </Grid>
        <Grid item sm={6}>
          <div className={classes.cardData}>State</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'account.state', '-')}</span>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <div className={classes.cardData}>Register As</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'account.registered_as', '-')}</span>
        </Grid>
        <Grid item sm={6}>
          <div className={classes.cardData}>Website (Optional)</div>
          <span className={classes.cardValue}>{_.get(selectedRequest, 'account.website', '-')}</span>
        </Grid>
      </Grid>
      <Box className={classes.actionStyle} mt={2}>
        <AppButton fullWidth text="Approve" onClick={() => approveRequest(selectedRequest)} />
        <AppButton fill={false} fullWidth text="Reject" onClick={() => rejectRequest(selectedRequest)} />
      </Box>
    </Box>
  )

  useEffect(() => {
    getAllRequests(props.currentUser.account_id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentUser.account_id, page, rowsPerPage])

  return (
    <>
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleMessageClose} />
      {!props.page && <Loader loading={loading} />}
      <CustomDialog open={openModal} fullWidth handleClose={handleClose} title="New Account Request" content={getDialogContent()} />
      {loading && props.page ? <ComponentLoader loading={loading} style={{ height: 230 }} /> :
        <TableOutline
          tableHeadings={props.columns || getTableHeadings(ACCOUNTS)}
          tableData={tableData}
          totalElement={totalCount}
          loading={loading}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          pagination={!props.page}
        />
      }
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, timeZone } = auth
  return { authUser, currentUser, timeZone }
}

export default connect(mapStateToProps)(AllRequests)